import { Filter } from '@e3dc-react/shell/Elements/Filter'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { Select } from '@e3dc-react/shell/Elements/Select'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { SystemlogResolvedType, SystemlogSort, SystemlogType } from 'src/Libs/installations/types'
import { SYSTEM_PROTOCOL_FILTER_ID } from 'src/Libs/qa/ids'
import { MultiSelectPlaceholderOptions, PlaceholderOptions } from 'src/Types/globalTypes'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  filterWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingRight: 0,
    },
  },
  sortFilter: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(2),
    },
  },
  paper: {
    paddingBottom: theme.spacing(2),
    width: '100%',
  },
}))

interface SystemProtocolFiltersProps {
  isFarm: boolean
  clientFilter: MultiSelectPlaceholderOptions<number>
  statusOptions: PlaceholderOptions<SystemlogResolvedType>
  typeOptions: PlaceholderOptions<SystemlogType>
  sortOptions: PlaceholderOptions<SystemlogSort>
  sortValue?: SystemlogSort
  onClientChange: (value: number[]) => void
  onStatusChange: (value: SystemlogResolvedType[]) => void
  onTypeChange: (value: SystemlogType[]) => void
  onSortChange: (value: SystemlogSort) => void
}

/**
 * Filter and sort controls for the system protocol entries
 */
const SystemProtocolFilters: React.FC<SystemProtocolFiltersProps> = ({
  isFarm,
  clientFilter,
  statusOptions,
  typeOptions,
  sortOptions,
  sortValue,
  onClientChange,
  onStatusChange,
  onTypeChange,
  onSortChange,
}) => {
  const { classes } = useStyles()

  return (
    <Paper className={classes.paper}>
      <Box className={classes.filterWrapper} data-qa={SYSTEM_PROTOCOL_FILTER_ID}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, md: 1 }} justifyContent={'space-between'}>
          {isFarm && <Filter<number> options={clientFilter.options} onChange={onClientChange} label={clientFilter.placeholder} />}
          <Filter<SystemlogResolvedType> options={statusOptions.options} onChange={onStatusChange} label={statusOptions.placeholder} />
          <Filter options={typeOptions.options} onChange={onTypeChange} label={typeOptions.placeholder} />
        </Stack>
        <Box className={classes.sortFilter}>
          <Select options={sortOptions.options} onChange={onSortChange} value={sortValue} label={sortOptions.placeholder} />
        </Box>
      </Box>
    </Paper>
  )
}

export default SystemProtocolFilters
